/**
 * Created by Jerker Nord on 2019-09-13.
 */
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {BonusBunniesGameConfig} from "../BonusBunniesGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BonusBunniesGameMode} from "../gamemode/BonusBunniesGameMode";
import {BonusBunniesParsedInitData} from "../server/data/BonusBunniesParsedInitData";
import {IBonusBunniesGameData} from "../server/data/IBonusBunniesGameData";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";

export class BonusBunniesReelAreaView extends ReelAreaView {

    private _bonusBunniesReelAreaMask:PIXI.Graphics | PIXI.Sprite;
    private _isExtraRow:boolean;
    private _restoreIntoBonusGame:boolean;
    private _currentMode:string;
    private _nextMode:string;
    private _bonusModeEnabled:boolean = false;
    private _disabledSpineSymbolsContainer:PIXI.Container;

    private _bonusGameRow0:PIXI.Container;
    private _bonusGameRow1:PIXI.Container;
    private _bonusGameRow2:PIXI.Container;
    private _bonusGameRow3:PIXI.Container;
    private _bonusGameRow4:PIXI.Container;
    private _bonusGameRows:PIXI.Container[];

    private _bonusGameRow0Mask:PIXI.Graphics;
    private _bonusGameRow1Mask:PIXI.Graphics;
    private _bonusGameRow2Mask:PIXI.Graphics;
    private _bonusGameRow3Mask:PIXI.Graphics;
    private _bonusGameRow4Mask:PIXI.Graphics;

    private _bonusGameReelBackground:PIXI.Sprite;
    private _bonusGameReelFrameImage:PIXI.Sprite;
    private _mainGameReelBackground:PIXI.Sprite;
    private _mainGameReelFrameImage:PIXI.Sprite;
    private _extraReel4Grid:PIXI.Sprite;
    private _extraReel5Grid:PIXI.Sprite;
    private _extraRow4Grid:PIXI.Sprite;
    private _extraRow5Grid:PIXI.Sprite;
    private _extraReel4GridContainer:PIXI.Container;
    private _extraReel5GridContainer:PIXI.Container;
    private _extraRow4GridContainer:PIXI.Container;
    private _extraRow5GridContainer:PIXI.Container;
    private _30LinesImage:PIXI.Sprite;
    private _reelFrameLayer:ScalableLayer;
    private _reelFrameContainer:PIXI.Container;
    private _reelBackgroundLayer:ScalableLayer;
    private _reelBackgroundContainer:PIXI.Container;
    private _orientation:string;
    private _lastReelActivated:boolean;
    private _bottomRowActivated:boolean;

    constructor(resourcesGroup?:ResourcesGroupName) {
        super(resourcesGroup);
        this.addEventHandlers();
        this._bonusGameRow0 = new PIXI.Container();
        this._bonusGameRow1 = new PIXI.Container();
        this._bonusGameRow2 = new PIXI.Container();
        this._bonusGameRow3 = new PIXI.Container();
        this._bonusGameRow4 = new PIXI.Container();
        this._bonusGameRow1.visible = false;
        this._bonusGameRow2.visible = false;
        this._bonusGameRow3.visible = false;
        this._bonusGameRow4.visible = false;
        this._extraReel4GridContainer = new PIXI.Container();
        this._extraReel5GridContainer = new PIXI.Container();
        this._extraRow4GridContainer = new PIXI.Container();
        this._extraRow5GridContainer = new PIXI.Container();
        this._extraReel4GridContainer.visible = false;
        this._extraReel5GridContainer.visible = false;
        this._extraRow4GridContainer.visible = false;
        this._extraRow5GridContainer.visible = false;
        this._reelFrameContainer = new PIXI.Container();
        this._reelBackgroundContainer = new PIXI.Container();
        this._disabledSpineSymbolsContainer = new PIXI.Container();
    }

    protected onResize(resizeData: IResizeData): void{
        this._orientation = resizeData.orientation;
        if (this._30LinesImage){
            if(resizeData.orientation == Orientation.LANDSCAPE) {
                this._30LinesImage.position.set(590, 0);
            } else {
                this._30LinesImage.position.set(484, 0);
            }
        }
    }

    private addEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:BonusBunniesParsedInitData):void {
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        this._lastReelActivated = data.lastReelActivated;
        this._bottomRowActivated = data.bottomRowActivated;
        if(this._currentMode == BonusBunniesGameMode.BONUS_GAME) {
            this._restoreIntoBonusGame = true;
        } else {
            this._restoreIntoBonusGame = false;
        }
    }

    private onGameDataParsed(data:IBonusBunniesGameData):void {
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        this._lastReelActivated = data.lastReelActivated;
        this._bottomRowActivated = data.bottomRowActivated;
    }

    protected initAnimations():void {
        this._reelFrameLayer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.REEL_ATTENTION.name);
        this._reelFrameLayer.addChild(this._reelFrameContainer);
        this._reelBackgroundLayer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.REEL_BACKGROUND.name);
        this._reelBackgroundContainer.position.set(46, 60);
        this._reelBackgroundLayer.addChild(this._reelBackgroundContainer);
        this._disabledSpineSymbolsContainer.position.set(-60, -84);
        this.addChild(this._disabledSpineSymbolsContainer);
        this._bonusGameReelBackground = new PIXI.Sprite(GameResources.getTextures("FS_mainReelBG")[0]);
        this._bonusGameReelBackground.position.set(5, 10);
        this._bonusGameReelBackground.visible = false;
        this._reelBackgroundContainer.addChild(this._bonusGameReelBackground);

        this._mainGameReelBackground = new PIXI.Sprite(GameResources.getTextures("mainReelBG")[0]);
        this._mainGameReelBackground.position.set(-4, -4);
        this._reelBackgroundContainer.addChild(this._mainGameReelBackground);

        this._bonusGameRows = [];
        this.addChild(this._bonusGameRow0);
        this._bonusGameRows.push(this._bonusGameRow0);
        this.addChild(this._bonusGameRow1);
        this._bonusGameRows.push(this._bonusGameRow1);
        this.addChild(this._bonusGameRow2);
        this._bonusGameRows.push(this._bonusGameRow2);
        this.addChild(this._bonusGameRow3);
        this._bonusGameRows.push(this._bonusGameRow3);
        this.addChild(this._bonusGameRow4);
        this._bonusGameRows.push(this._bonusGameRow4);

        for(let i:number = 0; i < this._bonusGameRows.length; i++) {
            for(let j:number = 0; j < 5; j++) {
                this._bonusGameRows[i].addChild(this._reelViews[(i * 5) + j]);
            }
            this._bonusGameRows[i].position.y = BonusBunniesGameConfig.instance.SYMBOL_HEIGHT * i;
        }

        this._extraReel4Grid = new PIXI.Sprite(GameResources.getTextures("extraReel4Grid")[0]);
        this._extraReel4GridContainer.position.set(670, 56);
        this._extraReel4GridContainer.addChild(this._extraReel4Grid);
        this._reelFrameContainer.addChild(this._extraReel4GridContainer);

        this._extraReel5Grid = new PIXI.Sprite(GameResources.getTextures("extraReel5Grid")[0]);
        this._extraReel5GridContainer.position.set(670, 56);
        this._extraReel5GridContainer.addChild(this._extraReel5Grid);
        this._reelFrameContainer.addChild(this._extraReel5GridContainer);

        this._extraRow4Grid = new PIXI.Sprite(GameResources.getTextures("extraRow4Grid")[0]);
        this._extraRow4GridContainer.position.set(12, 652);
        this._extraRow4GridContainer.addChild(this._extraRow4Grid);
        this._reelFrameContainer.addChild(this._extraRow4GridContainer);

        this._extraRow5Grid = new PIXI.Sprite(GameResources.getTextures("extraRow5Grid")[0]);
        this._extraRow5GridContainer.position.set(12, 652);
        this._extraRow5GridContainer.addChild(this._extraRow5Grid);
        this._reelFrameContainer.addChild(this._extraRow5GridContainer);

        this._bonusGameReelFrameImage = new PIXI.Sprite(GameResources.getTextures("FS_mainReel")[0]);
        this._bonusGameReelFrameImage.position.set(16, 16);
        this._bonusGameReelFrameImage.visible = false;
        this._reelFrameContainer.addChild(this._bonusGameReelFrameImage);

        this._mainGameReelFrameImage = new PIXI.Sprite(GameResources.getTextures("mainReelFrame")[0]);
        this._mainGameReelFrameImage.position.set(-116, -26);
        this._reelFrameContainer.addChild(this._mainGameReelFrameImage);

        this._30LinesImage = new PIXI.Sprite(GameResources.getTextures("30Lines")[0]);
        if(this._orientation == Orientation.LANDSCAPE) {
            this._30LinesImage.position.set(590, 0);
        } else {
            this._30LinesImage.position.set(484, 0);
        }
        if(this._currentMode == BonusBunniesGameMode.BONUS_GAME) {
            this._30LinesImage.visible = false;
        }
        this._reelFrameContainer.addChild(this._30LinesImage);

        this.x = GameConfig.instance.REEL_AREA_POS_X;
        this.y = GameConfig.instance.REEL_AREA_POS_Y;
        this._reelViews.forEach((reelView:PIXI.Container, reelId:number) => {
            this.updateReelViewPosition(reelView, reelId);
        });

        this.UpdateReelAreaMask();

        if(this._restoreIntoBonusGame == true) {
            this.initiBonusGame();
        }
    }

    public initiBonusGame():void {
        this.UpdateReelAreaMask();
        this.enableBonusGameMode();
    }

    protected UpdateReelAreaMask():void {
        if(GameConfig.instance.REEL_AREA_MASK === false) {
            return;
        }

        const rect:PIXI.Rectangle = GameConfig.instance.REEL_AREA_MASK_RECT != undefined ? GameConfig.instance.REEL_AREA_MASK_RECT :
            new PIXI.Rectangle(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y,
                GameConfig.instance.REEL_AREA_WIDTH, (GameConfig.instance.REEL_AREA_HEIGHT + this.calculateExtraRowHeight()));
        const maskShape = new PIXI.Graphics();
        maskShape.beginFill(0xFFFFFF, 1);
        maskShape.drawRect(rect.x - GameConfig.instance.REEL_AREA_POS_X, rect.y - GameConfig.instance.REEL_AREA_POS_Y, rect.width, rect.height);
        maskShape.endFill();

        if(this._bonusBunniesReelAreaMask != null) {
            this.removeChild(this._bonusBunniesReelAreaMask);
        }

        this._bonusBunniesReelAreaMask = maskShape;

        this.addChild(this._bonusBunniesReelAreaMask);
        this.mask = this._bonusBunniesReelAreaMask;

        if(this._bonusGameRow0Mask == null) {
            this._bonusGameRow0Mask = new PIXI.Graphics();
            this._bonusGameRow0Mask.beginFill(0xFFFFFF, 1);
            this._bonusGameRow0Mask.drawRect(rect.x - GameConfig.instance.REEL_AREA_POS_X, rect.y - GameConfig.instance.REEL_AREA_POS_Y, rect.width, rect.height - (BonusBunniesGameConfig.instance.SYMBOL_HEIGHT * 3) - 40);
            this._bonusGameRow0Mask.endFill();
        }

        if(this._bonusGameRow1Mask == null) {
            this._bonusGameRow1Mask = new PIXI.Graphics();
            this._bonusGameRow1Mask.beginFill(0xFFFFFF, 1);
            this._bonusGameRow1Mask.drawRect(rect.x - GameConfig.instance.REEL_AREA_POS_X, rect.y - GameConfig.instance.REEL_AREA_POS_Y, rect.width, rect.height - (BonusBunniesGameConfig.instance.SYMBOL_HEIGHT * 3) - 40);
            this._bonusGameRow1Mask.endFill();
            this._bonusGameRow1.addChild(this._bonusGameRow1Mask);
            this._bonusGameRow1.mask = this._bonusGameRow1Mask;
        }

        if(this._bonusGameRow2Mask == null) {
            this._bonusGameRow2Mask = new PIXI.Graphics();
            this._bonusGameRow2Mask.beginFill(0xFFFFFF, 1);
            this._bonusGameRow2Mask.drawRect(rect.x - GameConfig.instance.REEL_AREA_POS_X, rect.y - GameConfig.instance.REEL_AREA_POS_Y, rect.width, rect.height - (BonusBunniesGameConfig.instance.SYMBOL_HEIGHT * 3) - 40);
            this._bonusGameRow2Mask.endFill();
            this._bonusGameRow2.addChild(this._bonusGameRow2Mask);
            this._bonusGameRow2.mask = this._bonusGameRow2Mask;
        }

        if(this._bonusGameRow3Mask == null) {
            this._bonusGameRow3Mask = new PIXI.Graphics();
            this._bonusGameRow3Mask.beginFill(0xFFFFFF, 1);
            this._bonusGameRow3Mask.drawRect(rect.x - GameConfig.instance.REEL_AREA_POS_X, rect.y - GameConfig.instance.REEL_AREA_POS_Y, rect.width, rect.height - (BonusBunniesGameConfig.instance.SYMBOL_HEIGHT * 3) - 40);
            this._bonusGameRow3Mask.endFill();
            this._bonusGameRow3.addChild(this._bonusGameRow3Mask);
            this._bonusGameRow3.mask = this._bonusGameRow3Mask;
        }

        if(this._bonusGameRow4Mask == null) {
            this._bonusGameRow4Mask = new PIXI.Graphics();
            this._bonusGameRow4Mask.beginFill(0xFFFFFF, 1);
            this._bonusGameRow4Mask.drawRect(rect.x - GameConfig.instance.REEL_AREA_POS_X, rect.y - GameConfig.instance.REEL_AREA_POS_Y, rect.width, rect.height);
            this._bonusGameRow4Mask.endFill();
            this._bonusGameRow4.addChild(this._bonusGameRow4Mask);
            this._bonusGameRow4.mask = this._bonusGameRow4Mask;
        }
    }

    protected updateReelViewPosition(reelView:PIXI.Container, reelId:number):void {
        let position:[number, number] = BonusBunniesGameConfig.instance.REEL_DISPLAY_POSITIONS[reelId];
        if(this._currentMode == BonusBunniesGameMode.BONUS_GAME) {
            position = BonusBunniesGameConfig.instance.REEL_DISPLAY_POSITIONS_BONUS_GAME[reelId];
        }
        reelView.x = position[0];
        reelView.y = position[1];
    }

    public enableBonusGameMode():void {
        this._bonusModeEnabled = true;
        this._bonusGameReelFrameImage.visible = true;
        this._bonusGameReelBackground.visible = true;
        this._mainGameReelFrameImage.visible = false;
        this._mainGameReelBackground.visible = false;

        //Re-arrange all reels to get a different spin order in Bonus game
        for(let i:number = 0; i < 5; i++) {
            for(let j:number = 0; j < 5; j++) {
                this._bonusGameRows[j].addChild(this._reelViews[j + (5 * i)]);
            }
        }

        this._bonusGameRow1.visible = true;
        this._bonusGameRow2.visible = true;
        this._bonusGameRow3.visible = true;
        this._bonusGameRow4.visible = this._bottomRowActivated;
        this._bonusGameRow0.addChild(this._bonusGameRow0Mask);
        this._bonusGameRow0.mask = this._bonusGameRow0Mask;

        this._reelViews[20].visible = this._lastReelActivated;
        this._reelViews[21].visible = this._lastReelActivated;
        this._reelViews[22].visible = this._lastReelActivated;
        this._reelViews[23].visible = this._lastReelActivated;

        this._reelViews[4].visible = this._bottomRowActivated;
        this._reelViews[9].visible = this._bottomRowActivated;
        this._reelViews[14].visible = this._bottomRowActivated;
        this._reelViews[19].visible = this._bottomRowActivated;

        if (this._bottomRowActivated == true && this._lastReelActivated == true){
            this._reelViews[24].visible = true;
        }else{
            this._reelViews[24].visible = false;
        }

        this._reelViews.forEach((reelView:PIXI.Container, reelId:number) => {
            let position:[number, number] = BonusBunniesGameConfig.instance.REEL_DISPLAY_POSITIONS_BONUS_GAME[reelId];
            reelView.x = position[0];
            reelView.y = position[1];
        });
        this.UpdateReelAreaMask();
    }

    public disableBonusGameMode():void {
        this._bonusModeEnabled = false;
        this._bonusGameReelFrameImage.visible = false;
        this._bonusGameReelBackground.visible = false;
        this._mainGameReelFrameImage.visible = true;
        this._mainGameReelBackground.visible = true;

        this._bonusGameRow1.visible = false;
        this._bonusGameRow2.visible = false;
        this._bonusGameRow3.visible = false;
        this._bonusGameRow4.visible = false;
        this._bonusGameRow0.removeChild(this._bonusGameRow0Mask);
        // @ts-ignore
        this._bonusGameRow0.mask = null;

        for(let i:number = 0; i < 5; i++) {
            for(let j:number = 0; j < 5; j++) {
                this._bonusGameRows[i].addChild(this._reelViews[j + (i * 5)]);
            }
        }
        this._currentMode = BonusBunniesGameMode.NORMAL;
        this._reelViews.forEach((reelView:PIXI.Container, reelId:number) => {
            this.updateReelViewPosition(reelView, reelId);
        });

        this._reelViews[20].visible = false;
        this._reelViews[21].visible = false;
        this._reelViews[22].visible = false;
        this._reelViews[23].visible = false;
        this._reelViews[24].visible = false;

        this._reelViews[4].visible = false;
        this._reelViews[9].visible = false;
        this._reelViews[14].visible = false;
        this._reelViews[19].visible = false;

        this.UpdateReelAreaMask();
    }

    public enableExtraRow():void {
        this._bonusGameRow4.visible = true;
    }

    private calculateExtraRowHeight():number {
        let maskHeight:number = 0;
        if(this._bonusModeEnabled == true) {
            if(this._isExtraRow == true) {
                maskHeight = 110;
            } else {
                maskHeight = -40;
            }
        }
        return maskHeight;
    }

    public showReel(reel:number):void{
        this._reelViews[reel].visible = true;
    }

    public enable30LinesPicture():void {
        this._30LinesImage.visible = true;
    }

    public disable30LinesPicture():void {
        this._30LinesImage.visible = false;
    }

    set isExtraRow(value:boolean) {
        this._isExtraRow = value;
        this.UpdateReelAreaMask();
    }

    get disabledSpineSymbolsContainer():PIXI.Container {
        return this._disabledSpineSymbolsContainer;
    }

    get extraReel4GridContainer(): PIXI.Container {
        return this._extraReel4GridContainer;
    }

    set extraReel4GridContainer(value: PIXI.Container) {
        this._extraReel4GridContainer = value;
    }

    get extraReel5GridContainer(): PIXI.Container {
        return this._extraReel5GridContainer;
    }

    set extraReel5GridContainer(value: PIXI.Container) {
        this._extraReel5GridContainer = value;
    }

    get extraRow4GridContainer(): PIXI.Container {
        return this._extraRow4GridContainer;
    }

    set extraRow4GridContainer(value: PIXI.Container) {
        this._extraRow4GridContainer = value;
    }

    get extraRow5GridContainer(): PIXI.Container {
        return this._extraRow5GridContainer;
    }

    set extraRow5GridContainer(value: PIXI.Container) {
        this._extraRow5GridContainer = value;
    }
}